<section id="company-values">
    <h1>Valores</h1>

    <div class="col-value-container">
        <div class="col-value">
            <h3>Visão</h3>
            <p>Prover as melhores soluções de gerenciamento baseado em cloud com foco em simplicidade e resultado.</p>
        </div>

        <div class="col-value">
            <h3>Missão</h3>
            <p>Desenvolver e fornecer soluções de gestão empresarial através de softwares e serviços para potencializar a rentabilidade dos nossos clientes.</p>
        </div>

        <div class="col-value">
            <h3>Valores</h3>
            <p>Respeito, responsabilidade, relacionamento, qualidade, acessibilidade, integridade e aprendizado.</p>
        </div>
    </div>
</section>

<style>
.col-value {
    width: 100%;
    margin-bottom: 50px;
}

.col-value p {
    color: #666;
}

@media(min-width: 768px) {
    .col-value-container {
        display: flex;
        justify-content: space-around;    
    }

    .col-value {
        width: 33%;
        margin-bottom: 0;
        padding: 0 40px;
        text-align: center;    
    }
}
</style>